import { render, staticRenderFns } from "./WorkScheduleGroupNew.vue?vue&type=template&id=0b86b3e0"
import script from "./WorkScheduleGroupNew.vue?vue&type=script&lang=js"
export * from "./WorkScheduleGroupNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports